import { render } from "./PdfButton.vue?vue&type=template&id=2b1781b7&scoped=true&ts=true"
import script from "./PdfButton.vue?vue&type=script&lang=ts"
export * from "./PdfButton.vue?vue&type=script&lang=ts"

import "./PdfButton.vue?vue&type=style&index=0&id=2b1781b7&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b1781b7"]])

export default __exports__